import { motion } from "framer-motion";
import "./HeroSection.css";
import heroImage from "../../Images/real_estate_homepage.jpg";
import { useNavigate } from "react-router-dom";

export default function HeroSection() {
  const navigate = useNavigate();

  return (
    <section className="hero-container">
      {/* Background Image */}
      <motion.img
        src={heroImage}
        alt="Luxury Real Estate"
        className="hero-bg"
        initial={{ scale: 1.15 }}
        animate={{ scale: 1 }}
        transition={{ duration: 6, ease: "easeOut" }}
      />

      {/* Dark + Gradient Overlay */}
      <div className="hero-overlay"></div>

      {/* Content */}
      <div className="hero-content">
        <motion.p
          className="hero-subtitle"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1 }}
        >
          PREMIUM REAL ESTATE
        </motion.p>

        <motion.h1
          className="hero-title"
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.3, duration: 1 }}
        >
          Find Your Future <br />
          <span>Live in Luxury</span>
        </motion.h1>

        <motion.p
          className="hero-description"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.8, duration: 1 }}
        >
          Discover exclusive properties designed for comfort, elegance, and
          modern living.
        </motion.p>

        <motion.div
          className="hero-buttons"
          initial={{ opacity: 0, y: 50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 1, duration: 1 }}
        >
          <button
            className="btn-primary"
            onClick={() => navigate("/properties")}
          >
            Explore Properties
          </button>

          <button
            className="btn-secondary"
            onClick={() => navigate("/projects")}
          >
            View Projects
          </button>
        </motion.div>
      </div>
    </section>
  );
}